import { css } from '@emotion/css';

const styles = {
  section: css`
    padding: 0px 16px;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  endMessage: css`
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-bottom: 20px;
  `,
  seeMoreFlyersContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  seeMoreFlyersButton: css`
    text-transform: none !important;
  `,
};

export default styles;
